import types from "./customerTypes";

export default (state, action) => {
	switch (action.type) {
		case types.SET_LOADING:
			return {
				...state,
				loading: !state.loading
			};
		case types.SET_CUSTOMERS:
			return {
				...state,
				loading: false,
				customers: action.payload
			};
		default:
			return state;
	}
};